export default __webpack_public_path__ + "static/media/greenTick.0d9dbbde.svg";